module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Review history","company":"Company","event":"Event","comment":"Comment","reviewer":"Reviewer","reviewedAt":"Reviewed at","empty":"No review events yet."},"de":{"title":"Review-Verlauf","company":"Unternehmen","event":"Ereignis","comment":"Kommentar","reviewer":"Reviewer","reviewedAt":"Geprüft am","empty":"Noch keine Review-Ereignisse."}}')
  delete Component.options._Ctor
}
